import React from "react"
import styles from "./FullscreenError.module.scss"
import PublicPage from "../PublicPage/PublicPage"
import ctError from "../../assets/images/crafttalk/ctError.png"
import { useTranslation } from "react-i18next"
import { errorTranslation } from "../../locales/error"

export interface FullscreenErrorProps {
    title?: string
    message?: string
    hideLogo?: boolean
}

const FullscreenError: React.FC<FullscreenErrorProps> = props => {
    const { t } = useTranslation()
    const { title, message, hideLogo = false } = props
    const errorTitle = title || t(errorTranslation.title)
    return (
        <PublicPage
            hideLogo={hideLogo}
            hideLanguageSelector={true}
            hidePrivacyPolicy={true}
            hideTermOfUse={true}
            className={styles.fullscreenError}
            contentInCenter
        >
            <div className={styles.fullscreenError__content}>
                <h1 className={styles.fullscreenError__title}>{errorTitle}</h1>
                {message && <p className={styles.fullscreenError__message}>{message}</p>}
                <div className={styles.fullscreenError__image}>
                    <img src={ctError} alt="error" />
                </div>
            </div>
        </PublicPage>
    )
}

export default FullscreenError
